const Web3 = require("web3");

let web3 = new Web3(Web3.givenProvider);

export const WEB3 = {
  privateKeyToAccount: (privateKey: string) => {
    return web3.eth.accounts.privateKeyToAccount(privateKey);
  },
  signTransaction: async ({
    nonce,
    chainId,
    to,
    data,
    value,
    gas,
    gasPrice,
    privateKey,
  }: {
    nonce: string;
    chainId: number | string;
    to: string;
    data?: string;
    value?: string;
    gas: string;
    gasPrice: string;
    privateKey: string;
  }) => {
    return await web3.eth.accounts.signTransaction(
      {
        nonce,
        chainId,
        to,
        ...(data && { data }),
        ...(value && { value }),
        gas,
        gasPrice,
      },
      privateKey
    );
  },
  Contract: (abiCode: any[]) => {
    return new web3.eth.Contract(abiCode);
  },
  toWei: (amount: string) => {
    if (!amount) {
      return web3.utils.toWei("0");
    }
    return web3.utils.toWei(amount);
  },
  fromWei: (wei: string | number) => {
    try {
      let weiString = wei;
      if (typeof wei === "number") {
        weiString = wei.toString();
      }
      return web3.utils.fromWei(weiString);
    } catch (e) {
      return "-";
    }
  },
  toHex: (decimal: string) => {
    return web3.utils.toHex(decimal);
  },
  toDecimal: (hex: string) => {
    return web3.utils.toDecimal(hex);
  },
  isHex: (hex: string) => {
    return web3.utils.isHex(hex);
  },
  toBN: (amount: string) => {
    return web3.utils.toBN(amount);
  },
  add: (amount1: string, amount2: string) => {
    const BN1 = web3.utils.toBN(amount1);
    const BN2 = web3.utils.toBN(amount2);
    return BN1.add(BN2).toString();
  },
  sub: (amount1: string, amount2: string) => {
    const BN1 = web3.utils.toBN(amount1);
    const BN2 = web3.utils.toBN(amount2);
    return BN1.sub(BN2).toString();
  },
  mul: (amount1: string, amount2: string) => {
    const BN1 = web3.utils.toBN(amount1);
    const BN2 = web3.utils.toBN(amount2);
    return BN1.mul(BN2).toString();
  },
  div: (amount1: string, amount2: string) => {
    const BN1 = web3.utils.toBN(amount1);
    const BN2 = web3.utils.toBN(amount2);
    return BN1.div(BN2).toString();
  },
  gt: (amount1: string, amount2: string) => {
    const BN1 = web3.utils.toBN(amount1);
    const BN2 = web3.utils.toBN(amount2);
    return BN1.gt(BN2);
  },
  lt: (amount1: string, amount2: string) => {
    const BN1 = web3.utils.toBN(amount1);
    const BN2 = web3.utils.toBN(amount2);
    return BN1.lt(BN2);
  },
  lte: (amount1: string, amount2: string) => {
    const BN1 = web3.utils.toBN(amount1);
    const BN2 = web3.utils.toBN(amount2);
    return BN1.lte(BN2);
  },
};
